import { combineEpics } from 'redux-observable';
import shiftsEpic from './shiftsEpic';
import trackingEpic from './trackingEpic';
import jobEpic from './jobEpic';
import shiftsCreateEpic from './shiftsCreateEpic';
import cancelShiftsEpic from './cancelShiftsEpic';
import jobInvitationsEpic from './jobInvitationsEpic';
import acceptInvitationEpic from './acceptInvitationEpic';
import rejectInvitationEpic from './rejectInvitationEpic';
import freelancersEpic from './freelancersEpic';
import clientsEpic from './clientsEpic';
import {
    uploadFreelancersEpic,
    createFreelancersEpic,
} from './upload_freelancers_epic';
import { sendSMSEpic } from './send_sms_epic';
import { sendNotificationEpic } from './send_notification_epic';
import bookingsEpic from './bookingsEpic';
import trackingMapEpic from './trackingMapEpic';
import subscriptionsEpic from './subscriptionsEpic';
import {
    loadNotificationsEpic,
    loadNotificationsCountersEpic,
} from './notificationsEpic';
import loadInductionSessionsEpic from './InductionSessionsEpic';
import unallocatedFreelancersEpic from './unallocatedFreelancersEpic';

export default combineEpics(
    shiftsEpic,
    trackingEpic,
    jobEpic,
    shiftsCreateEpic,
    cancelShiftsEpic,
    jobInvitationsEpic,
    acceptInvitationEpic,
    rejectInvitationEpic,
    freelancersEpic,
    unallocatedFreelancersEpic,
    clientsEpic,
    uploadFreelancersEpic,
    createFreelancersEpic,
    sendSMSEpic,
    sendNotificationEpic,
    bookingsEpic,
    trackingMapEpic,
    loadNotificationsEpic,
    loadNotificationsCountersEpic,
    subscriptionsEpic,
    loadInductionSessionsEpic
);
